<template>
  <Skeleton v-if="!userReady" height="28px" width="28px" class="margin-left-xs" />
  <button v-else-if="isSignedIn" class="margin-left-xs" data-block-outside-click @click="openMenuWithAccount">
    <i class="icon-28x28 profile-dark-large"></i>
  </button>
  <Link v-else :href="Links.account.signIn.url" :tracking="Links.account.signIn.tracking" class="link-body margin-left-xs" @click="useSignInClick">
    Sign In
  </Link>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { ref } from 'vue';
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton';
import Link from '~/components/common/Link';
import Links from '#shared/constants/Links';
import useAccount from '~/composables/useAccount';
import useSignInClick from '~/composables/useSignInClick';
import useMenuWithAccount from '~/composables/features/useMenuWithAccount';
import { onUserInit } from '~/events';

const userReady = ref(false);
const { isSignedIn } = useAccount();
const { openMenuWithAccount } = useMenuWithAccount();

onUserInit(() => {
  userReady.value = true;
});
</script>

<style lang="scss"></style>
